import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../auth.service';
import { Certificate, CertificateTemplate, CertificateText } from '../data/certificate-layout';
import { EmailCertificateModalComponent } from '../email-certificate-modal/email-certificate-modal.component';

@Component({
  selector: 'app-certificate-renderer',
  templateUrl: './certificate-renderer.component.html',
  styleUrls: ['./certificate-renderer.component.css']
})
export class CertificateRendererComponent implements OnInit {
  @Input() template: Certificate
  @ViewChild("canvas", { static: false }) canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("emailModal", { static: false }) emailModal: EmailCertificateModalComponent;
  isParent: boolean;

  constructor( private authService: AuthService ) { }

  ngOnInit(): void {
    this.isParent = this.authService.isParent();
    const image = new Image();
    image.src = this.template.previewTemplate.src;
    image.onload = () => this.renderCertificate(this.template.previewTemplate, this.template.contents, image, this.canvas.nativeElement);
  }

  downloadCertificate() {
    const image = new Image();
    image.src = this.template.downloadTemplate.src;
    const virtualCanvas = document.createElement("canvas");
    image.onload = () => {
      this.renderCertificate(this.template.downloadTemplate, this.template.contents, image, virtualCanvas);
      const anchor = document.createElement("a");
      anchor.href = virtualCanvas.toDataURL("image/png");
      anchor.download = this.template.downloadName;
      anchor.click();
    }
  }

  printCertificate() {
    const image = new Image();
    image.src = this.template.printTemplate.src;
    const printCanvas = document.createElement("canvas");
    image.onload = () => {
      this.renderCertificate(this.template.printTemplate, this.template.contents, image, printCanvas);
      let printWindow = window.open();
      printWindow.document.write("<style>@page{size:landscape;} body{margin:0;}</style><body></body>");
      printWindow.document.title = "Joy School";
      printWindow.document.body.appendChild(printCanvas);
      printWindow.print();
      printWindow.close();
    }
  }

  emailCertificate() {
    const image = new Image();
    image.src = this.template.downloadTemplate.src;
    const virtualCanvas = document.createElement("canvas");
    image.onload = () => {
      this.renderCertificate(this.template.downloadTemplate, this.template.contents, image, virtualCanvas);
      const base64 = virtualCanvas.toDataURL("image/png").split(';base64,')[1];
      const subject = this.template.downloadName.replace(/_/g, " ");
      this.emailModal.addAttachment(subject, base64);
      this.emailModal.openForNew();
    }
  }

  renderCertificate(template: CertificateTemplate, contents: CertificateText[], image: HTMLImageElement, canvas: HTMLCanvasElement) {
    const context = canvas.getContext("2d");
    canvas.height = template.height;
    canvas.width = template.width;
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.drawImage(image, 0, 0, template.width, template.height);

    for (const content of contents) {
      let fontSize = Math.round(template.height * content.heightPercent / 100);
      context.font = `${fontSize}px ${content.font}`;
      const nameSize = context.measureText(content.text).width;
      const pixelWidth = template.width * content.widthPercent / 100;
      if (nameSize > pixelWidth) {
        const compressionRatio = pixelWidth / nameSize;
        fontSize = Math.floor(compressionRatio * fontSize);
        context.font = `${fontSize}px ${content.font}`;
      }
      context.fillStyle = content.color;
      context.fillText(content.text, template.width * content.xPercent / 100, template.height * content.yPercent / 100, pixelWidth);
    }
  }

}
